var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMessageCircleIconGray(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 6.66669C13.5023 7.5466 13.2967 8.41461 12.9 9.20002C12.4296 10.1412 11.7065 10.9328 10.8116 11.4862C9.91677 12.0396 8.8855 12.3329 7.83333 12.3334C6.95342 12.3356 6.08541 12.1301 5.3 11.7334L1.5 13L2.76667 9.20002C2.36995 8.41461 2.16437 7.5466 2.16667 6.66669C2.16707 5.61452 2.46041 4.58325 3.01381 3.68839C3.56722 2.79352 4.35884 2.0704 5.3 1.60002C6.08541 1.20331 6.95342 0.997725 7.83333 1.00002H8.16667C9.55623 1.07668 10.8687 1.66319 11.8528 2.64726C12.8368 3.63132 13.4233 4.94379 13.5 6.33335V6.66669Z",
    stroke: "#535762",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageCircleIconGray);
export default __webpack_public_path__ + "static/media/message-circle-icon-gray.7cdc431ee00990306c6add33b374cd7b.svg";
export { ForwardRef as ReactComponent };